export default "/assets/website/images/st3.jpeg?7bc3c67c8f836c8676acb88c22c92f05";